<div>
  <a class="id37-link" (click)="goToFriend()">{{friendName}}</a>
  <span> {{__('messageA')}}</span>
  <a class="id37-link" (click)="goToCompareSite()">{{__('messageB')}}</a>
  <span> {{messageC}}</span>
</div>

